import { VISUAL_01 } from "../../data/reportContent";

export const Visual01 = () => (
  <section id={VISUAL_01.id} className="visual-block" data-testid="visual-01-section">
    <div className="visual-head">
      <span className="report-kicker">{VISUAL_01.number}</span>
      <h2>{VISUAL_01.title}</h2>
      <p>{VISUAL_01.intro}</p>
    </div>

    <div className="report-table-wrap" style={{ overflowX: "auto" }} data-testid="visual-01-table">
      <table className="v1-table" style={{ minWidth: 640 }}>
        <thead>
          <tr>
            <th>As-is: accumulated tools</th>
            <th>Change: simplify &amp; prove</th>
            <th>Target: connected operating model</th>
          </tr>
        </thead>
        <tbody>
          {VISUAL_01.rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <div className="v1-band millism" data-testid="visual-01-millism-band">{VISUAL_01.millism}</div>
    <div className="v1-band not-now" data-testid="visual-01-notnow-band">{VISUAL_01.notNow}</div>

    <p className="visual-note">{VISUAL_01.note}</p>
  </section>
);
